import React, { useCallback } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';

import { ErrorScreen } from './error-screen';

// Mirrors `searchDialogStyles` in `./index` by hand. Importing it would pull the whole dialog back
// into the eager chunk, and the dialog is what failed to load here in the first place.
const unavailableStyles = xcss({
	display: 'flex',
	position: 'absolute',
	flexDirection: 'column',
	backgroundColor: 'elevation.surface.overlay',
	boxShadow: 'elevation.shadow.overlay',
	width: '100%',
	borderRadius: token('radius.small'),
	marginTop: 'space.100',
});

/**
 * Error fallback for the lazily loaded Quick Find dialog.
 *
 * Reuses the dialog's own `ErrorScreen` so a chunk failure looks like every other Quick Find
 * error. Importing `./error-screen` is cheap because splitting is per module, not per directory,
 * and its illustration already sits behind its own `React.lazy` boundary.
 *
 * "Try again" reloads rather than re-importing: a failed chunk cannot recover within the session.
 */
export const SearchDialogUnavailable = (): React.JSX.Element => {
	const onRetry = useCallback(() => {
		window.location.reload();
	}, []);

	return (
		<Box xcss={unavailableStyles} role="status">
			<ErrorScreen onRetry={onRetry} />
		</Box>
	);
};
